import i18next from 'i18next';
import 'react-i18next';
import { initReactI18next } from 'react-i18next';
import enLang from './translations/en';
import ptLang from './translations/pt';

i18next.use(initReactI18next).init({
    fallbackLng: 'pt',
    debug: true,
    resources: {
        pt: {
            translation: ptLang,
        },
        en: {
            translation: enLang,
        }
    },
    detection: {},
});

export type LanguageKeys = 'pt' | 'en';

declare module 'i18next' {
    interface CustomTypeOptions {
        defaultNS: 'pt';
        resources: {
            pt: typeof ptLang;
            en: typeof ptLang;
        };
    }
}

export const handleToggleLanguages = (isNotDefault: boolean) => {
    if (isNotDefault) return i18next.changeLanguage('en');
    i18next.changeLanguage('pt');
};
